import React from 'react';
import './CourseList.less';
import Course from '../Course/Course.jsx';
import { observer } from 'mobx-react';
import { Row, Item } from 'react-plan';

const CourseList = observer(['courses', 'enrollments'], ({courses, enrollments}) => {
  const renderCourses = courses.all.map(
    ([id, course]) =>
      <Course
        course={ course }
        id={ id }
        key={ id }
        progress={ enrollments.courses.get(id) }
      />
  );

  return (
    <div>
      <h1 className="m-t-xl text-center">My Courses</h1>
      <Row className="bloc-small bloc-course course-list m-t-xl">
        { renderCourses }
      </Row>
    </div>
  );
});

export default CourseList;

//Unit test entry point
export const CourseListTest = CourseList;


/** WEBPACK FOOTER **
 ** ./src/js/course/CourseList/CourseList.jsx
 **/